import React, { useEffect, useRef, useState } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  TextField,
  MenuItem,
  Button,
} from "@mui/material";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { useFormik } from "formik";
import { FaBusinessTime, FaNewspaper } from "react-icons/fa";
import { AiOutlineEdit } from "react-icons/ai";
import { server } from "../../../common";
import { useSelectAccess } from "../../../store/stateFunctions";
import { NavLink, useNavigate } from "react-router-dom";
import { AxiosError } from "axios";

const IndustryProfile = () => {
  const user = useSelectAccess("Industry User");
  const [photoModal, setPhoto] = useState(false);
  const [profielphoto, setprofilephoto] = useState([]);
  const [orgdetails, setOrgDetails] = useState([]);
  const [profile, setProfile] = useState([]);
  const closePhotoModal = () => setPhoto(false);

  const [initialValues, setInitialValues] = useState({
    business_name: "",
    owner: "",
    mobile: "",
    email: "",
    details: "",
    address: "",
    landmark: "",
    city: "",
    pincode: "",
    location: "",
    url1: "",
    image: null,
    image2: null,
  });

  const navigate = useNavigate();

  useEffect(() => {
    getData();
    getBusinessData();
    getProfilePhoto();
  }, []);

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: Yup.object({
      business_name: Yup.string().required("Enter a Your Business Name"),
      owner: Yup.string().required("Enter a Owner name"),
      mobile: Yup.string().required("Enter a Contact Number"),
      email: Yup.string().required("Enter a Business Email Id"),
      details: Yup.string().required("Enter a Your Business Details"),
      address: Yup.string().required("Enter a Address"),
      landmark: Yup.string().required("Enter a Landmark"),
      city: Yup.string().required("Enter a City"),
      pincode: Yup.string().required("Enter a Pincode"),
      location: Yup.string().required("Enter a Google Location link"),
      url1: Yup.string().required("Enter a Business Website Link"),
      image: Yup.mixed()
        .required("Please select an image")
        .test("fileSize", "File size is too large", (value) => {
          return value ? value.size <= 5000000 : true;
        }),
      image2: Yup.mixed()
        .required("Please select an image")
        .test("fileSize", "File size is too large", (value) => {
          return value ? value.size <= 5000000 : true;
        }),
    }),
    onSubmit: (values, action) => {
      if (!values.image) {
        toast.error("Please select a images for verification");
        return;
      }
      if (!values.image2) {
        toast.error("Please select a image Of Shop Act / Pan Card");
        return;
      }
      const formData = new FormData();
      formData.append("business_name", values.business_name);
      formData.append("owner", values.owner);
      formData.append("mobile", values.mobile);
      formData.append("email", values.email);
      formData.append("details", values.details);
      formData.append("address", values.address);
      formData.append("landmark", values.landmark);
      formData.append("city", values.city);
      formData.append("pincode", values.pincode);
      formData.append("location", values.location);
      formData.append("url1", values.url1);
      formData.append("image", values.image);
      formData.append("image2", values.image2);

      server
        .post("/orgdetails/addorg_details", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: user.authToken,
          },
        })
        .then(function (response) {
          if (response.status === 200 || response.status === 201) {
            toast.success("Details Sent successfully");
            formik.resetForm();
            getBusinessData();
          }
        })
        .catch(function (error) {
          if (error.response?.data?.message)
            toast.error(error.response.data.message);
          else if (error.response?.data?.error) {
            toast.error(error.response.data.error);
          } else toast.error("Failed to connect to server");
        });
    },
  });

  // Get profile Data
  const getData = () => {
    server
      .get("/register/organizationprofile", {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then((response) => {
        setProfile(response.data);
      })
      .catch((error) => {
        if (error.response?.status === 401) {
          navigate("/loginorg");
        }
        console.log(
          "error",
          error.message,
          error.response?.status,
          error.response?.data,
          error
        );
      });
  };

  // Get organisation details
  const getBusinessData = () => {
    server
      .get("/orgdetails/getindorg_details", {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setOrgDetails(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        }
      });
  };

  const isStatusSent = orgdetails.some(
    (data) => data.status === "Sent" || data.status === "Reviewed"
  );
  const isStatusreject = orgdetails.some((data) => data.status === "Rejected");

  const isOrganizationDetailsAvailable = orgdetails.some(
    (data) => data.status === "Approved"
  );

  // Get profile photo
  const getProfilePhoto = () => {
    server
      .get("/org_profile/getallprofile_photo", {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setprofilephoto(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  const fileInputRef = useRef();

  // profile photo
  const AddProfilePicture = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("org_image", fileInputRef.current.files[0]);
    try {
      if (user.profilePhotoId) {
        // If user already has a profile photo, update it
        await server.put(
          `/org_profile/updateprofile_photo/${profielphoto.id}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: user.authToken,
            },
          }
        );
        toast.success("Profile Photo updated successfully");
      } else {
        // If user does not have a profile photo, add it
        const response = await server.post(
          "/org_profile/addorg_photo",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: user.authToken,
            },
          }
        );

        toast.success("Profile Photo added successfully");
      }

      formik.resetForm();
      closePhotoModal();
    } catch (error) {
      if (error instanceof AxiosError && error.response?.data?.message)
        toast.error(error.response.data.message);
      else if (error.response?.data?.error) {
        toast.error(error.response.data.error);
      } else {
        toast.error("Failed to connect to the server");
        console.log(error.message);
      }
    }
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    // Do something with the selected file
  };

  return (
    <>
      <section>
        <div className="container py-2">
          <div className="row">
            <div className="col">
              <nav
                aria-label="breadcrumb"
                className="bg-light rounded-3 p-3 mb-4"
              >
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li className="breadcrumb-item">
                    <a href="/">User</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    User Profile
                  </li>
                </ol>
              </nav>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4">
              <div className="card " style={{ height: "14rem" }}>
                <div className="card-body text-center">
                  {profielphoto.map((photo) => (
                    <img
                      key={photo.id} // Use a unique key for each image if available
                      src={photo.org_image}
                      alt="avatar"
                      className="rounded-circle img-fluid cropped-image"
                      style={{ width: 100 }}
                    />
                  ))}
                  <h5 className="my-3">{profile.name}</h5>

                  <div className="d-flex justify-content-center mb-2">
                    <button
                      size="sm"
                      className="banner btn-sm rounded-3 ms-2 p-2 text-white border-0"
                      onClick={() => setPhoto(true)}
                    >
                      &nbsp; Profile Photo
                    </button>
                    <button
                      size="sm"
                      className="banner btn-sm rounded-3 ms-2 p-2 text-white border-0"
                    >
                      &nbsp;
                      <NavLink
                        to="/industryprofile/editindustryprofile"
                        className="text-white"
                      >
                        Edit Profile
                      </NavLink>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-8">
              <div className="card mb-4" style={{ height: "14rem" }}>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <p className="mb-0">Organization Name :</p>
                    </div>
                    <div className="col-sm-8">
                      <p className=" mb-0">{profile.organization_name}</p>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-md-4">
                      <p className="mb-0">Business Email :</p>
                    </div>
                    <div className="col-sm-8">
                      <p className=" mb-0">{profile.business_email}</p>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-md-4">
                      <p className="mb-0">Contact Number : </p>
                    </div>
                    <div className="col-sm-8">
                      <p className=" mb-0">{profile.org_contact}</p>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-md-4">
                      <p className="mb-0">Organization Type : </p>
                    </div>
                    <div className="col-sm-8">
                      <p className=" mb-0">{profile.org_type}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <section>
          {!isOrganizationDetailsAvailable &&
            isStatusSent &&
            orgdetails.map((item) => {
              return (
                <div className="card p-2">
                  <p>
                    <h5>Status:</h5>
                    <span>
                      Your Organization Details has been{" "}
                      <b className="text-success">{item.status} </b>
                      please wait for Approval.
                    </span>
                  </p>
                </div>
              );
            })}

          {!isOrganizationDetailsAvailable &&
            isStatusreject &&
            orgdetails.map((item) => {
              return (
                <div className="card p-2">
                  <p>
                    <h5>Status:</h5>
                    <span>
                      Your Organization Details has been{" "}
                      <b className="text-danger">{item.status}</b> please Fill
                      Correct Data.
                    </span>
                  </p>
                </div>
              );
            })}
          <div className="container-xl mb-2">
            {!isOrganizationDetailsAvailable && !isStatusSent && (
              <div className="multistep-form container p-5">
                <section>
                  <div className="container-xl mb-5">
                    <form
                      className="needs-validation d-flex flex-column gap-2"
                      onSubmit={formik.handleSubmit}
                    >
                      <div className="">
                        <h5 className="mb-3">Business Details</h5>
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <TextField
                              name="business_name"
                              //   margin="dense"
                              type="text"
                              value={formik.values.business_name}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              placeholder="Shop Name"
                              variant="outlined"
                              label="Business Name"
                              fullWidth
                              required
                            ></TextField>
                            <p className="text-danger">
                              {formik.errors.business_name}
                            </p>
                          </div>

                          <div className="col-md-6  mb-3">
                            <TextField
                              name="owner"
                              //   margin="dense"
                              type="text"
                              value={formik.values.owner}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              placeholder="Owner's Full Name"
                              variant="outlined"
                              label="Owner"
                              fullWidth
                              required
                            ></TextField>
                            <p className="text-danger">{formik.errors.owner}</p>
                          </div>
                        </div>
                        <div className="row  mb-3">
                          <div className="col-md-6">
                            <TextField
                              name="mobile"
                              //   margin="dense"
                              type="number"
                              value={formik.values.mobile}
                              onChange={formik.handleChange}
                              // disabled={!!props.edit}
                              onBlur={formik.handleBlur}
                              placeholder="Mobile Number"
                              variant="outlined"
                              label="Business Mobile Number"
                              fullWidth
                              required
                            ></TextField>
                            <p className="text-danger">
                              {formik.errors.mobile}
                            </p>
                          </div>

                          <div className="col-md-6">
                            <TextField
                              name="email"
                              //   margin="dense"
                              type="email"
                              value={formik.values.email}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              placeholder="Business Email"
                              variant="outlined"
                              label="Business Email"
                              fullWidth
                              required
                            ></TextField>
                            <p className="text-danger">{formik.errors.email}</p>
                          </div>
                        </div>
                        <div className=" mb-3">
                          <TextField
                            name="details"
                            // margin="dense"
                            type="text"
                            value={formik.values.details}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            placeholder="Describe your business (min 200 chars)"
                            variant="outlined"
                            label="Business Details"
                            fullWidth
                            multiline
                            minRows={3}
                            required
                          ></TextField>
                          <p className="text-danger">{formik.errors.details}</p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6 gap-3 align-items-center mb-2">
                          <label htmlFor="image data-name">
                            Organization/Institute Photos (jpg/png/jpeg)
                          </label>
                          <br />
                          <br />
                          <input
                            name="image"
                            className="form-control"
                            type="file"
                            onChange={(event) => {
                              formik.setFieldValue(
                                "image",
                                event.currentTarget.files[0]
                              );
                            }}
                            // accept=".jpg,.png,.jpeg"
                          />
                          <p className="text-danger">{formik.errors.image}</p>
                        </div>
                        <div className="col-md-6 gap-3 align-items-center mb-2">
                          <label htmlFor="image data-name">
                            Business Shop Act/Pan Card/Udyam (pdf)
                          </label>
                          <br />
                          <br />
                          <input
                            name="image2"
                            type="file"
                            className="form-control"
                            onChange={(event) => {
                              formik.setFieldValue(
                                "image2",
                                event.currentTarget.files[0]
                              );
                            }}
                            // accept=".jpg,.png,.jpeg"
                          />
                          <p className="text-danger">{formik.errors.image2}</p>
                        </div>
                      </div>
                      <div>
                        <h5 className="mb-3">Address Details</h5>
                        <div>
                          <div className="row  mb-3">
                            <div className="col-md-6">
                              <TextField
                                name="address"
                                type="text"
                                //   margin="dense"
                                value={formik.values.address}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                placeholder="Address"
                                variant="outlined"
                                label="Address"
                                fullWidth
                                required
                              ></TextField>
                              <p className="text-danger">
                                {formik.errors.address}
                              </p>
                            </div>
                            <div className="col-md-6">
                              <TextField
                                name="landmark"
                                type="text"
                                //   margin="dense"
                                value={formik.values.landmark}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                placeholder="Near Natraj Society"
                                variant="outlined"
                                label="Landmark"
                                fullWidth
                                required
                              ></TextField>
                              <p className="text-danger">
                                {formik.errors.landmark}
                              </p>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-md-6 mb-3">
                              <TextField
                                name="city"
                                type="text"
                                //   margin="dense"
                                value={formik.values.city}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                placeholder="City"
                                variant="outlined"
                                label="City"
                                fullWidth
                                required
                              ></TextField>
                              <p className="text-danger">
                                {formik.errors.city}
                              </p>
                            </div>
                            <div className="col-md-6 mb-3">
                              <TextField
                                name="pincode"
                                type="number"
                                //   margin="dense"
                                value={formik.values.pincode}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                placeholder="412216"
                                variant="outlined"
                                label="pincode"
                                fullWidth
                                required
                              ></TextField>
                              <p className="text-danger">
                                {formik.errors.pincode}
                              </p>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-6">
                              <div>
                                <TextField
                                  name="location"
                                  type="text"
                                  //   margin="dense"
                                  value={formik.values.location}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  placeholder="Geo Location"
                                  variant="outlined"
                                  label="Organization/Institute Geo Location"
                                  fullWidth
                                  required
                                ></TextField>
                                <p className="text-danger">
                                  {formik.errors.location}
                                </p>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div>
                                <TextField
                                  name="url1"
                                  type="text"
                                  //   margin="dense"
                                  value={formik.values.url1}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  placeholder="Website Url"
                                  variant="outlined"
                                  label="Website Url"
                                  fullWidth
                                  required
                                ></TextField>
                                <p className="text-danger">
                                  {formik.errors.url1}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="text-center">
                        <span className="mb-1 d-block">
                          <input type="checkbox" name="" id="" /> &nbsp; All The
                          Above Information is Correct and If It Is Wrong Then I
                          Am Responsible For The Same.
                        </span>
                        <Button
                          className="banner text-white p-1 rounded-2 border-0 w-50"
                          type="submit"
                        >
                          Save
                        </Button>
                      </div>
                    </form>
                  </div>
                </section>
              </div>
            )}
          </div>
        </section>

        {/* Conditionally render organization details */}
        {orgdetails?.map(
          (data) =>
            data.status === "Approved" && (
              <div className="organization-details-container">
                <div className="row ">
                  <div className="col-md-10">
                    <h2 className="organization-details-title">
                      Business Details
                    </h2>
                  </div>
                  <div className="col-md-2 text-end">
                    <NavLink
                      className="banner text-white p-1 rounded-2 border-0 "
                      to="/industryprofile/editorganization"
                    >
                      Edit Details
                    </NavLink>
                  </div>
                </div>

                <div className="row">
                  <div className="col-lg-6">
                    <div className="card mb-4">
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-4">
                            <p className="mb-0">Business Name :</p>
                          </div>
                          <div className="col-md-8">
                            <p className=" mb-0">{data?.business_name}</p>
                          </div>
                        </div>
                        <hr />
                        <div className="row">
                          <div className="col-md-4">
                            <p className="mb-0">Business Email :</p>
                          </div>
                          <div className="col-md-8">
                            <p className=" mb-0">{data?.email}</p>
                          </div>
                        </div>
                        <hr />
                        <div className="row">
                          <div className="col-md-4">
                            <p className="mb-0">Owner Name :</p>
                          </div>
                          <div className="col-md-8">
                            <p className=" mb-0">{data?.owner}</p>
                          </div>
                        </div>

                        <hr />
                        <div className="row">
                          <div className="col-md-4">
                            <p className="mb-0">Organization Details :</p>
                          </div>
                          <div className="col-md-8">
                            <p className=" mb-0">{data?.details}</p>
                          </div>
                        </div>
                        <hr />
                        <div className="row">
                          <div className="col-md-4">
                            <p className="mb-0">Website :</p>
                          </div>
                          <div className="col-md-8">
                            <p className=" mb-0">
                              <a href={data?.url1}>{data?.url1}</a>
                            </p>
                          </div>
                        </div>
                        <hr />
                        <div className="row">
                          <div className="col-md-4">
                            <p className="mb-0">Status :</p>
                          </div>
                          <div className="col-md-8">
                            <b className=" mb-0 text-success">{data?.status}</b>
                          </div>
                        </div>
                        <hr />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="card mb-4">
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-4">
                            <p className="mb-0">Organization Address :</p>
                          </div>
                          <div className="col-md-8">
                            <p className=" mb-0">{data?.address}</p>
                          </div>
                        </div>
                        <hr />
                        <div className="row">
                          <div className="col-md-4">
                            <p className="mb-0">Organization City :</p>
                          </div>
                          <div className="col-md-8">
                            <p className=" mb-0">{data?.city}</p>
                          </div>
                        </div>
                        <hr />
                        <div className="row">
                          <div className="col-md-4">
                            <p className="mb-0">Landmark :</p>
                          </div>
                          <div className="col-md-8">
                            <p className=" mb-0">{data?.landmark}</p>
                          </div>
                        </div>

                        <hr />
                        <div className="row">
                          <div className="col-md-4">
                            <p className="mb-0">Google Location Link :</p>
                          </div>
                          <div className="col-md-8">
                            <p className=" mb-0">{data?.address}</p>
                          </div>
                        </div>
                        <hr />
                        <div className="row">
                          <div className="col-md-4">
                            <p className="mb-0">Pincode :</p>
                          </div>
                          <div className="col-md-8">
                            <p className=" mb-0">{data?.pincode}</p>
                          </div>
                        </div>
                        <hr />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )
        )}
      </section>

      <Modal show={photoModal} onHide={closePhotoModal}>
        <Modal.Header>
          <Modal.Title>
            <h5>Upload Your Profile Photo</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={(e) => AddProfilePicture(e, user)}>
            <div className="form-outline mb-2">
              <input
                name="org_image"
                margin="dense"
                type="file"
                className="form-control"
                onChange={handleFileChange}
                ref={fileInputRef}
                fullWidth
                required
              />
            </div>
            <Button variant="contained" className="ms-2" type="submit">
              Upload
            </Button>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default IndustryProfile;
